import { ChangeEvent } from 'react';

import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';
import { camelCaseToCapitalizedWords } from 'src/lib/formatters';

interface PartnerFeaturesProps {
    handlePermissionsChange: (event: ChangeEvent<HTMLInputElement>) => void;
    permissions: object;
}

const PartnerFeatures = ({ handlePermissionsChange, permissions }: PartnerFeaturesProps) => {
    const permissionLabels = Object.entries(permissions).map(([key, value]) => (
        <Grid item xs={12} sm={3} key={key}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={permissions[key]}
                        onChange={handlePermissionsChange}
                        name={key}
                    />
                }
                label={camelCaseToCapitalizedWords(key)}
            />
        </Grid>
    ));

    return (
        <Grid container>
            <Grid
                item
                sx={{
                    ...DEFAULT_BORDER,
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                    height: 'fit-content',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '24px',
                    padding: '32px 24px',
                }}
                container
            >
                {/**sub-heading section */}
                <Grid
                    item
                    xs={12}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item md={6} xs={12}>
                        <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B' }}>
                            User Role features
                        </Typography>
                        <Typography>Set features to relate to your new user role</Typography>
                    </Grid>
                </Grid>

                {/**partner features items section */}
                <Grid item marginTop="35px" display="flex" flexWrap="wrap">
                    <Grid container spacing={2}>
                        {permissionLabels}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PartnerFeatures;
